<template>
  <div class="news-detail-page column-me" :class="{'mobile-mode': isMobile}">
    <!-- 文章内容 -->
    <div class="content-section column-me center-all">
      <div class="section-content column-me row-center pB80">
        <div class="w100Per">
          <div class="mT80 mLR160 animate-section header-wrapper" ref="headerSection">
            <img src="../../assets/img/home/go.png" class="img30 objScaleDown animate-back-btn"
                 draggable="false" @click="clickBack">
            <div class="h450 row-me mT25 header-content">
              <div class="flex1 article-header animate-slide-left column-me">
                <el-tooltip :content="articleData.title" placement="bottom"
                            :disabled="isMobile || !articleData.title || articleData.title.length < 50" effect="light"
                            popper-class="title-tooltip">
                  <div class="article-title font-db line3">{{ articleData.title }}</div>
                </el-tooltip>
                <div class="flex1"></div>
                <div class="font24 colorBlack font-n article-date">{{ articleData.date }}</div>
                <div class="row-me row-center flex-wrap mT30 category-wrapper">
                  <div class="article-category animate-category-tag font-n"
                       v-for="(item, index) in articleData.category" :key="index"
                       :style="{animationDelay: `${0.4 + index * 0.1}s`}">
                    {{ item }}
                  </div>
                </div>
                <div class="row-me row-center mT80 share-wrapper">
                  <div class="row-me center-all img50 border-all-orange pointer animate-share-btn"
                       style="border-right: none; animation-delay: 0.7s;">
                    <img src="../../assets/img/academic/wechat.png" class="img35 objScaleDown share-icon"
                         draggable="false" @click="showWechatQrcode">
                  </div>
                  <div class="row-me center-all img50 border-all-orange pointer animate-share-btn"
                       style="animation-delay: 0.85s;">
                    <img src="../../assets/img/academic/msg.png" class="img35 objScaleDown share-icon" draggable="false"
                         @click="showEmailDialog">
                  </div>
                </div>
              </div>
              <div class="flex1 mL100 animate-slide-right image-wrapper" v-if="articleData.mainImage">
                <img :src="articleData.mainImage" class="wh100Per objFitCover article-main-img" draggable="false">
              </div>
            </div>
          </div>
        </div>
        <div class="w1400 mT70 animate-section font-n content-wrapper" ref="contentSection">
          <div class="font22 article-content-text" style="color: #7F7E7E;" v-if="articleData.content"
               v-html="this.$method.formatRichText(articleData.content)"></div>
        </div>
        <div class="row-me center-all mT50">
          <div class="btn-p pointer row-me center-all anim-bigger-small" @click="clickBack">
            <div class="font24 font-n">{{ $t('common.backToPrevious') }}</div>
            <img src="../../assets/img/home/go.png" class="img30 objScaleDown mL10" draggable="false">
          </div>
        </div>
      </div>
    </div>
    <!-- 微信二维码弹窗 -->
    <el-dialog v-model="wechatDialogVisible" :width="isMobile ? '80%' : '320px'" center
               custom-class="wechat-qrcode-dialog">
      <template #header>
        <div class="dialog-title" :class="{'dialog-title-mobile': isMobile}">{{ $t('common.wechatQrcode') }}</div>
      </template>
      <div class="qrcode-container" :class="{'qrcode-container-mobile': isMobile}">
        <img src="../../assets/img/code.png" class="qrcode-img" :class="{'qrcode-img-mobile': isMobile}"
             draggable="false">
      </div>
    </el-dialog>
    <!-- 邮箱弹窗 -->
    <el-dialog v-model="emailDialogVisible" :width="isMobile ? '80%' : '320px'" center
               custom-class="wechat-qrcode-dialog">
      <template #header>
        <div class="dialog-title" :class="{'dialog-title-mobile': isMobile}">{{
            $t('common.emailAddress') || '邮箱地址'
          }}
        </div>
      </template>
      <div class="email-container" :class="{'email-container-mobile': isMobile}">
        <div class="email-text" :class="{'email-text-mobile': isMobile}">{{ emailAddress }}</div>
        <div class="copy-btn" :class="{'copy-btn-mobile': isMobile}" @click="copyEmail">{{
            $t('common.copy') || '复制'
          }}
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {ArrowLeft} from "@element-plus/icons";
import {deviceState} from "@/utils/device";
import {getArticleDetail, getImageUrl} from "@/http/api";
import bus from "@/assets/js/bus";

export default {
  components: {
    ArrowLeft
  },
  data() {
    return {
      deviceState,
      articleId: null,
      wechatDialogVisible: false, // 微信二维码弹窗显示状态
      emailDialogVisible: false, // 邮箱弹窗显示状态
      emailAddress: 'info@bjywmedical.com', // 邮箱地址
      // 新闻数据 - 完全从API获取
      articleData: {
        id: null,
        title: '',
        category: [],
        author: '',
        date: '',
        views: 0,
        intro: '',
        mainImage: '',
        content: ''
      }
    }
  },
  computed: {
    isMobile() {
      return this.deviceState.isMobile
    }
  },
  created() {
    this.articleId = this.$route.query.id
    // 加载新闻详情
    if (this.articleId) {
      this.loadNewsDetail()
    }
    // 手机端初始化时检查可见区域
    if (this.isMobile) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.checkVisibleSections()
        }, 50)
      })
    }
  },
  mounted() {
    this.initScrollAnimation()
    // 确保页面加载时立即检查可见区域
    this.$nextTick(() => {
      this.checkVisibleSections()
    })
    // 监听语言切换事件
    bus.$on('language-changed', this.onLanguageChanged)
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect()
    }
    bus.$off('language-changed', this.onLanguageChanged)
  },
  activated() {
    this.$nextTick(() => {
      this.resetAnimations()
      // 重新检查可见区域
      setTimeout(() => {
        this.checkVisibleSections()
      }, 100)
    })
  },
  methods: {
    // 语言切换时重新加载数据
    onLanguageChanged() {
      if (this.articleId) {
        this.loadNewsDetail()
      }
    },
    // 加载新闻详情
    async loadNewsDetail() {
      try {
        const res = await getArticleDetail(this.articleId)
        if (res && res.code === 200 && res.data) {
          const data = res.data
          // 解析标签为数组
          let categoryArray = []
          if (data.tags) {
            categoryArray = data.tags.split(',').map(tag => tag.trim()).filter(tag => tag)
          }
          this.articleData = {
            id: data.id,
            title: data.title || '',
            category: categoryArray,
            author: data.categoryName || '',
            date: data.publishTime ? data.publishTime.split(' ')[0].replace(/-/g, '/') : '',
            views: data.viewCount || 0,
            intro: data.summary || '',
            mainImage: getImageUrl(data.coverImage),
            content: data.content || ''
          }
        }
      } catch (error) {
        console.error('加载新闻详情失败:', error)
      }
    },
    // 重置所有动画
    resetAnimations() {
      const sections = [
        this.$refs.headerSection,
        this.$refs.contentSection
      ]

      sections.forEach(section => {
        if (section) {
          section.classList.remove('animate-in')
        }
      })

      this.$nextTick(() => {
        // 重置返回按钮动画
        const backBtn = document.querySelector('.animate-back-btn')
        if (backBtn) {
          backBtn.style.animation = 'none'
          setTimeout(() => {
            backBtn.style.animation = ''
          }, 10)
        }

        // 重置分类标签动画
        const categoryTags = document.querySelectorAll('.animate-category-tag')
        categoryTags.forEach(tag => {
          tag.style.animation = 'none'
          setTimeout(() => {
            tag.style.animation = ''
          }, 10)
        })

        // 重置分享按钮动画
        const shareBtns = document.querySelectorAll('.animate-share-btn')
        shareBtns.forEach(btn => {
          btn.style.animation = 'none'
          setTimeout(() => {
            btn.style.animation = ''
          }, 10)
        })
      })
    },
    // 初始化滚动动画
    initScrollAnimation() {
      const options = {
        threshold: 0.15,
        rootMargin: '0px 0px -50px 0px'
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in')
          }
        })
      }, options)

      const sections = [
        this.$refs.headerSection,
        this.$refs.contentSection
      ]

      sections.forEach(section => {
        if (section) {
          this.observer.observe(section)
        }
      })
    },
    // 检查当前视口中可见的区块，立即触发它们的动画
    checkVisibleSections() {
      const sections = [
        this.$refs.headerSection,
        this.$refs.contentSection
      ]

      // 手机端直接触发所有动画，确保内容可见
      if (this.isMobile) {
        sections.forEach(section => {
          if (section) {
            section.classList.add('animate-in')
          }
        })
        return
      }

      sections.forEach(section => {
        if (section) {
          const rect = section.getBoundingClientRect()
          const windowHeight = window.innerHeight || document.documentElement.clientHeight
          const threshold = 0.85

          if (rect.top < windowHeight * threshold && rect.bottom > 0) {
            section.classList.add('animate-in')
          }
        }
      })
    },
    clickBack() {
      this.$router.back()
    },
    // 显示微信二维码弹窗
    showWechatQrcode() {
      this.wechatDialogVisible = true
    },
    // 显示邮箱弹窗
    showEmailDialog() {
      this.emailDialogVisible = true
    },
    // 复制邮箱地址
    copyEmail() {
      const successMsg = this.$t('common.copySuccess') || '复制成功'
      const text = this.emailAddress
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      textarea.style.left = '-9999px'
      textarea.style.top = '-9999px'
      document.body.appendChild(textarea)
      textarea.focus()
      textarea.select()
      try {
        const successful = document.execCommand('copy')
        if (successful) {
          this.$message.success(successMsg)
        } else {
          navigator.clipboard.writeText(text).then(() => {
            this.$message.success(successMsg)
          }).catch(() => {
            this.$message.error('复制失败')
          })
        }
      } catch (err) {
        navigator.clipboard.writeText(text).then(() => {
          this.$message.success(successMsg)
        }).catch(() => {
          this.$message.error('复制失败')
        })
      }
      document.body.removeChild(textarea)
    }
  },
  watch: {
    $route: {
      handler(to, from) {
        if (to.path === '/articleDetail' && from && from.path !== '/articleDetail') {
          setTimeout(() => {
            this.resetAnimations()
            window.scrollTo({top: 0, behavior: 'smooth'})
          }, 50)
        }
      },
      immediate: false
    }
  }
}
</script>

<style lang="scss" scoped>
.news-detail-page {
  width: 100%;
  background-image: url("../../assets/img/academic/bg_artical.jpg");
  background-repeat: repeat;
  scroll-behavior: smooth;
  overflow: hidden;

  .btn-p {
    padding: 0 20px;
    height: 46px;
    line-height: 46px;
    background: #EDEDF1;
    border-radius: 23px 23px 23px 23px;
  }
}

// 滚动触发动画
.animate-section {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;

  &.animate-in {
    opacity: 1;
    transform: translateY(0);
  }
}

// 返回按钮动画和悬停效果
.animate-back-btn {
  cursor: pointer;
  opacity: 0;
  animation: bounceIn 0.8s ease-out 0.2s both;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    opacity: 1 !important;
    transform: scale(1.2) !important;
    filter: drop-shadow(0 8px 16px rgba(234, 128, 99, 0.4)) !important;
  }

  &:active {
    opacity: 1 !important;
    transform: scale(1.1) !important;
  }
}

@keyframes bounceIn {
  0% {
    opacity: 0;
    transform: scale(0.3);
  }
  50% {
    opacity: 1;
    transform: scale(1.1);
  }
  70% {
    transform: scale(0.9);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

// 左侧滑入动画
.animate-slide-left {
  opacity: 0;
  transform: translateX(-60px);
  transition: all 0.8s ease-out 0.3s;
}

// 右侧滑入动画
.animate-slide-right {
  opacity: 0;
  transform: translateX(60px);
  transition: all 0.8s ease-out 0.4s;
}

.animate-section.animate-in {
  .animate-slide-left,
  .animate-slide-right {
    opacity: 1;
    transform: translateX(0);
  }
}

// 分类标签动画
.animate-category-tag {
  opacity: 0;
  transform: translateY(-20px) scale(0.8);
  animation: tagFadeIn 0.6s ease-out forwards;
}

@keyframes tagFadeIn {
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

// 分享按钮动画和悬停效果
.animate-share-btn {
  opacity: 0;
  transform: scale(0);
  animation: scaleIn 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
  position: relative;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    border-radius: 50%;
    background: rgba(234, 128, 99, 0.3);
    transform: translate(-50%, -50%);
    transition: width 0.6s, height 0.6s;
  }

  &:hover {
    opacity: 1 !important;
    background: #EA8063 !important;
    border-color: #EA8063 !important;
    transform: scale(1) !important;
    box-shadow: 0 8px 20px rgba(234, 128, 99, 0.4) !important;

    &::before {
      width: 200%;
      height: 200%;
    }

    .share-icon {
      transform: scale(1.1);
      filter: brightness(0) invert(1);
    }
  }

  &:active {
    opacity: 1 !important;
    transform: translateY(-3px) scale(1.05) !important;
  }

  .share-icon {
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    z-index: 1;
  }
}

@keyframes scaleIn {
  to {
    opacity: 1;
    transform: scale(1);
  }
}

// 文章主图动画
.article-main-img {
  animation: imageZoom 1s ease-out 0.5s both;
}

@keyframes imageZoom {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

// 文章内容文本动画
.article-content-text {
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.8s ease-out 0.2s;
}

.animate-section.animate-in {
  .article-content-text {
    opacity: 1;
    transform: translateY(0);
  }
}

// 文章内容悬停效果
.article-content-hover {
  padding: 40px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(234, 128, 99, 0.1);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    background: linear-gradient(45deg, #EA8063, #B2C2E3, #F7EEF3, #EA8063);
    background-size: 300% 300%;
    border-radius: 12px;
    opacity: 0;
    z-index: -1;
    transition: opacity 0.4s ease;
    animation: gradientShift 3s ease infinite;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.9);
    border-color: rgba(234, 128, 99, 0.3);
    box-shadow: 0 12px 40px rgba(234, 128, 99, 0.15);
    transform: translateY(-5px);

    &::before {
      opacity: 1;
    }

    .content-paragraph {
      color: #2C2B30;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    }

    .highlight-text {
      color: #EA8063;
      background: linear-gradient(120deg, #EA8063 0%, #FF8C4D 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  .content-paragraph {
    transition: all 0.3s ease;
    line-height: 2;
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .highlight-text {
    font-weight: bold;
    transition: all 0.3s ease;
    position: relative;
    display: inline-block;
  }
}

@keyframes gradientShift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

// Banner样式
.banner-section {
  width: 100%;
  height: 400px;
  background: linear-gradient(135deg, #0A2540 0%, #1A3A5A 100%);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 10%;

  .banner-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.2);
  }

  .banner-content {
    position: relative;
    z-index: 1;
    color: #FFFFFF;

    .banner-title {
      font-size: 48px;
      font-weight: bold;
      line-height: 1.2;
    }

    .banner-subtitle {
      font-size: 28px;
      color: #EA8063;
    }
  }
}

// 文章头部
.article-header {
  .article-category {
    font-size: 18px;
    color: #2C2B30;
    padding: 5px 15px;
    background: #F7EEF3;
    margin-right: 30px;
  }

  .article-title {
    font-size: 48px;
    color: #2C2B30;
    line-height: 1.5;
  }

  .article-meta {
    font-size: 14px;
    color: #999999;

    .meta-divider {
      width: 1px;
      height: 12px;
      background: #CCCCCC;
      margin: 0 15px;
    }
  }
}

// 文章正文
.article-body {
  width: 100%;

  .article-intro {
    font-size: 18px;
    color: #666666;
    line-height: 1.8;
    padding: 20px;
    background: #F8F9FA;
    border-left: 4px solid #EA8063;
    border-radius: 4px;
  }

  .article-main-image {
    width: 100%;
    text-align: center;
    border-radius: 8px;
    overflow: hidden;
  }

  .article-content {
    .content-section-item {
      margin-bottom: 40px;

      .content-subtitle {
        font-size: 24px;
        font-weight: bold;
        color: #013D5C;
        margin-bottom: 20px;
        padding-bottom: 15px;
        border-bottom: 2px solid #EA8063;
      }

      .content-paragraph {
        font-size: 16px;
        color: #666666;
        line-height: 1.8;
        margin-bottom: 15px;
        text-align: justify;
      }

      .content-image {
        width: 100%;
        text-align: center;
        border-radius: 8px;
        overflow: hidden;
      }
    }
  }
}

// ==================== 手机端适配样式 ====================
// 微信二维码弹窗样式
.dialog-title {
  font-size: 18px;
  font-weight: bold;
  color: #FFFFFF;
  text-align: center;
  letter-spacing: 2px;

  &.dialog-title-mobile {
    font-size: 25px;
  }
}

.qrcode-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;

  &.qrcode-container-mobile {
    padding: 30px 20px 40px;
  }
}

.qrcode-img {
  width: 200px;
  height: 200px;
  object-fit: contain;

  &.qrcode-img-mobile {
    width: 100%;
    max-width: 400px;
    height: auto;
    aspect-ratio: 1;
    // 允许长按保存图片
    -webkit-touch-callout: default;
    -webkit-user-select: auto;
    user-select: auto;
  }
}

// 邮箱弹窗样式
.email-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;

  &.email-container-mobile {
    padding: 30px 20px 40px;
  }
}

.email-text {
  font-size: 16px;
  color: #2C2B30;
  text-align: center;
  word-break: break-all;
  padding: 20px;
  background: #F5F5F5;
  border-radius: 8px;
  width: 100%;
  box-sizing: border-box;

  &.email-text-mobile {
    font-size: 24px;
    padding: 25px;
  }
}

.copy-btn {
  margin-top: 20px;
  padding: 10px 40px;
  font-size: 16px;
  color: #FFFFFF;
  background: #013D5C;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #025A87;
  }

  &:active {
    background: #012A40;
  }

  &.copy-btn-mobile {
    font-size: 24px;
    padding: 15px 60px;
    margin-top: 30px;
  }
}


.news-detail-page.mobile-mode {
  background: #FFFFFF;
  padding-top: 120px;

  .btn-p {
    margin-top: 30px !important;
    padding: 0 20px;
    height: 50px;
    line-height: 50px;

    .font24 {
      font-size: 24px !important;
    }

    .img30 {
      width: 30px !important;
      height: 30px !important;
      margin-left: 8px !important;
      object-fit: cover;
    }
  }

  // 内容区域适配
  .content-section {
    .section-content {
      width: 100%;
      padding-bottom: 40px !important;

      .mT80 {
        margin-top: 30px !important;
      }

      .mLR160 {
        margin-left: 60px !important;
        margin-right: 60px !important;
      }
    }
  }

  // 头部区域
  .header-wrapper {
    .animate-back-btn {
      width: 40px !important;
      height: 40px !important;
      object-fit: cover;
    }

    .header-content {
      flex-direction: column !important;
      height: auto !important;
      margin-top: 30px !important;

      .article-header {
        width: 100%;

        .article-title {
          font-size: 46px !important;
          line-height: 1.4;
          // 移动端取消行数限制
          -webkit-line-clamp: unset !important;
          display: block !important;
          overflow: visible !important;
          text-overflow: unset !important;
          max-height: none !important;
        }

        .article-date {
          font-size: 24px !important;
          margin-top: 40px;
        }

        .category-wrapper {
          margin-top: 15px !important;

          .article-category {
            font-size: 18px !important;
            padding: 5px 15px;
            margin-right: 10px !important;
            margin-bottom: 8px;
          }
        }

        .share-wrapper {
          margin-top: 15px !important;

          .img50 {
            width: 60px !important;
            height: 60px !important;
          }

          .img35 {
            width: 25px !important;
            height: 25px !important;
            object-fit: contain;
          }
        }
      }

      .image-wrapper {
        width: 100%;
        margin-left: 0 !important;
        margin-top: 30px;
        height: 200px;
      }
    }
  }

  // 内容区域
  .content-wrapper {
    width: 100% !important;
    padding: 0 60px;
    box-sizing: border-box;
    margin-top: 30px !important;

    .article-content-text {
      font-size: 22px !important;
      line-height: 1.8;
    }
  }
}
</style>

<!-- 全局样式 - tooltip 弹出层样式 -->
<style lang="scss">
.title-tooltip {
  max-width: 600px !important;
  font-size: 16px !important;
  line-height: 1.6 !important;
  padding: 12px 16px !important;
  color: #2C2B30 !important;
  background: #FFFFFF !important;
  border: 1px solid #E8E8E8 !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1) !important;

  .el-tooltip__arrow::before {
    background: #FFFFFF !important;
    border-color: #E8E8E8 !important;
  }
}

// 手机端tooltip样式
@media (max-width: 768px) {
  .title-tooltip {
    max-width: 80vw !important;
    font-size: 24px !important;
    padding: 16px 20px !important;
  }
}
</style>
